// This is a bugfix for Includable, although this breaks support for rgb etc.
export default (color) => (color.indexOf('#') !== 0 ? `#${color}` : color)
